// extracted by mini-css-extract-plugin
export default {"badge":"RoleBadge_badge__SroYX","admin":"RoleBadge_admin__4e-Qd","manager":"RoleBadge_manager__ayTDE","member":"RoleBadge_member__7PwRp","viewer":"RoleBadge_viewer__aMaSt"};